import { breakpoints, theme } from '@notino/react-styleguide';

import ProgressBar from '@components/ProgressBar';
import { styled } from '@linaria/react';

export const RatingRowButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 0.8rem;
  height: 1.875rem;
  padding: 0 0.5rem;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: start;

  transition: all 0.3s ease;

  cursor: pointer;

  &:hover {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
    border-radius: 0.25rem;
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    border-radius: 0.25rem;
  }
`;

export const ProgressWrapper = styled.span`
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RatingsValue = styled.span`
  display: flex;
  margin-right: 0.75rem;
`;

export const StarsBox = styled.span`
  display: inline-block;
`;

export const StarsValue = styled.span`
  display: inline-block;
  padding-right: 0.25rem;
  ${theme.typography.labelSmall400};
`;

export const ReviewsCount = styled.span`
  ${theme.typography.labelSmall400};
  color: ${theme.color.text.secondary};
`;

export const StarReviews = styled.div`
  @media (min-width: ${breakpoints.md}) {
    width: 40%;
  }
`;

export const StyledProgressBar = styled(ProgressBar)`
  width: calc(100% - 30px);
`;
